import { useSearchParams } from 'react-router-dom'

const useParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const params: Record<string, string> = {}
  searchParams.forEach((value, key) => {
    params[key] = value
  })
  return { params, setSearchParams }
}

export { useParams }
